import { Component, input, output } from '@angular/core'
import { ElevioTriggerDirective, IconButtonComponent, IconComponent, TooltipModule } from '@ftr/foundation'
import { featureFlag, LaunchDarklyModule } from '@ftr/ui-feature-flags'
import { HelpModule } from '@ftr/ui-help'
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap'
import { SideNavDisplayMode } from '../../navigation'
import { LogoSize, LogoTheme } from '../../types'
import { FtrLogoComponent } from '../ftr-logo'

@Component({
  selector: 'ftr-header-logged-out',
  templateUrl: './header-logged-out.component.html',
  styleUrls: ['./header-logged-out.component.css'],
  imports: [
    FtrLogoComponent,
    TooltipModule,
    IconComponent,
    LaunchDarklyModule,
    IconButtonComponent,
    HelpModule,
    NgbPopoverModule,
    ElevioTriggerDirective,
  ],
})
export class HeaderLoggedOutComponent {
  displayMode = input<SideNavDisplayMode>('DEFAULT')
  isHelpMenuOpen = input<boolean>(false)
  addLinkToFtrLogo = input<boolean>(false)
  helpButtonClicked = output()

  readonly logoThemes = LogoTheme
  readonly logoSizes = LogoSize

  isPublicNavigationEnabled = featureFlag('public-navigation')
}
